import { render, staticRenderFns } from "./PriTama01.vue?vue&type=template&id=27cd8935&scoped=true&"
import script from "./PriTama01.vue?vue&type=script&lang=js&"
export * from "./PriTama01.vue?vue&type=script&lang=js&"
import style0 from "./PriTama01.vue?vue&type=style&index=0&id=27cd8935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd8935",
  null
  
)

export default component.exports